module.exports = __webpack_public_path__ + "img/floor2.9ced8762.jpg";